module.exports = __webpack_public_path__ + "static/img/40004 (1).7303eea.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/40000/40004 (1).webp
// module id = L/VB
// module chunks = 14